/**
 * Shared constants used across the audit-logs feature.
 */

/**
 * Object types that use campaign-specific value formatting.
 * Newsletter uses similar terminology and field mappings as Campaign.
 */
export const CAMPAIGN_OBJECT_TYPES = new Set(['Campaign', 'CampaignAction', 'Newsletter']);

/**
 * Object types that use condition-specific formatting (operator field).
 * Uses OperatorLabels from segment-mapping.ts to display human-readable operator names.
 */
export const CONDITION_OBJECT_TYPES = new Set(['Condition']);

/**
 * Permission field names that should be formatted specially.
 */
export const PERMISSION_FIELD_NAMES = new Set([
  'account_permissions',
  'accountpermissions',
  'permissions',
  'user_permissions',
  'userpermissions',
]);
